import { z } from 'zod';

import { ScanStatus } from '../enums.js';

import { Ulid } from './common.js';

export const LeadDocument = z.object({
  id: Ulid,
  leadId: Ulid,
  projectId: Ulid,
  uploaderUserId: Ulid,
  filename: z.string().min(1),
  originalFilename: z.string().min(1),
  mimeType: z.string().min(1),
  sizeBytes: z.number().int().nonnegative(),
  storageKey: z.string().min(1),
  checksumSha256: z.string().regex(/^[a-f0-9]{64}$/, 'expected lowercase hex sha256'),
  virusScanStatus: ScanStatus,
  createdAt: z.string().datetime(),
  deletedAt: z.string().datetime().nullable(),
});
export type LeadDocument = z.infer<typeof LeadDocument>;

/** Step 1 of the upload flow — reserve an id and a signed PUT URL. */
export const DocumentInitRequest = z.object({
  originalFilename: z.string().min(1).max(260),
  mimeType: z.string().min(1).max(120),
  sizeBytes: z
    .number()
    .int()
    .positive()
    .max(500 * 1024 * 1024, 'max 500 MB'),
  checksumSha256: z.string().regex(/^[a-f0-9]{64}$/),
});
export type DocumentInitRequest = z.infer<typeof DocumentInitRequest>;

export const DocumentInitResponse = z.object({
  documentId: Ulid,
  uploadUrl: z.string().url(),
  uploadHeaders: z.record(z.string()),
  expiresAt: z.string().datetime(),
});
export type DocumentInitResponse = z.infer<typeof DocumentInitResponse>;

/** Step 2 of the upload flow — confirm the bytes landed and persist metadata. */
export const DocumentFinalizeRequest = z.object({
  documentId: Ulid,
});
export type DocumentFinalizeRequest = z.infer<typeof DocumentFinalizeRequest>;

export const DocumentDownloadResponse = z.object({
  url: z.string().url(),
  expiresAt: z.string().datetime(),
});
export type DocumentDownloadResponse = z.infer<typeof DocumentDownloadResponse>;
